import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import CommonComments from "./../../../app/common/Comments";
import PaginationComponent from "./../../../../src/app/common/Pagination";
import { ReportType, ModuleType, makeLinkForQuickbooks, Base64, numberWithCommas, LinkType } from "./../../../app/common/commonServices";
import moment from 'moment';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../components/CircularProgress';
import { GET_REPORT_DATA_BES, MARK_IGNORED_DATA_BES, Revert_Ignored_DATA_BES, UpdateTransactionCheckNumber_BES } from "./../../../appRedux/actions/ReportDetailAction";
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import Textarea from 'react-expanding-textarea';

// MissRefNo embed — notes, Got It, Prev Ignored, checkboxes (parity with company).
class MissRefNo_Embedded extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parantData: this.props.location.state ? this.props.location.state : null,
            MissingData: [],
            companyId: 0,
            sortField: 'date',
            sortFormat: "D",
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#e27b40",
            IsCommentModelOpen: false,
            sDate: new Date(2019, 0, 1),
            eDate: new Date(),
            loading: false,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: true,
            HomeLink: "",
            companyName: "",
            isEdited: false,
            SelectedRecords: [],
            SelectALL: false,
            IsIgnoredFilter: false
        }
    }

    onCheckboxClick = (e, item) => {
        e.stopPropagation();
        let existInArray = false;
        let data = this.state.SelectedRecords;
        if (data != null && data.length > 0 && data.indexOf(item.id) > -1) {
            existInArray = true;
        }
        if (e.target.checked) {
            if (!existInArray) {
                data.push(item.id);
            }
        }
        else {
            if (existInArray) {
                data.splice(data.indexOf(item.id), 1);
            }
        }
        let all = (data.length == this.state.MissingData.length) ? true : false;
        this.setState({ SelectedRecords: data, SelectALL: all });
    }

    SelectALL = (e) => {
        e.stopPropagation();
        if (this.state.MissingData.length > 0) {
            if (e.target.checked) {
                let all = [];
                let data = this.state.MissingData;
                for (let i = 0; i < data.length; i++) {
                    all.push(data[i].id);
                }
                this.setState({ SelectALL: true, SelectedRecords: all });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }

    OnApplyIgnore = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }
        let body = {
            "ids": selectedData,
            "reportType": ReportType.ChecksMissingReferenceNumber,
            "companyID": this.state.companyId
        }
        this.setState({ loading: true }, () => {
            if (this.state.IsIgnoredFilter) {
                this.props.Revert_Ignored_DATA_BES(body);
            }
            else {
                this.props.MARK_IGNORED_DATA_BES(body);
            }
        });
    }

    HandleIgnored = (event) => {
        this.setState({ IsIgnoredFilter: (event.target.value == "true" ? true : false), PageNo: 1, loading: true, SelectedRecords: [], SelectALL: false }, () => { this.GetReportData() });
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField == fieldName) {
            let formate = this.state.sortFormat == 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => {
                this.GetReportData();
            });
        }
    }

    componentDidMount() {
        let value = queryString.parse(this.props.location.search);
        let dashboardURl = localStorage.getItem("homeURL");
        this.setState({
            loading: true,
            HomeLink: dashboardURl ? dashboardURl : "?q=" + value.q + "&p=" + value.p
        }, () => {
            this.getCompanyId();
        });
    }

    getCompanyId = () => {
        let value = queryString.parse(this.props.location.search);
        localStorage.setItem("q", JSON.stringify(value));
        let data = localStorage.getItem("q");
        if (data != null && data !== undefined) {
            data = JSON.parse(data);
            this.setState({
                companyId: parseInt(Base64.decode(data.q)),
                companyName: Base64.decode(data.p),
                loading: true
            }, () => {
                this.GetReportData();
            });
        }
        else {
            this.setState({ loading: false });
        }
    }

    ChangePageSize = (size) => {
        this.setState({ loading: true, PageSize: parseInt(size), PageNo: 1, SelectedRecords: [], SelectALL: false }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({ loading: true, PageNo: page, SelectedRecords: [], SelectALL: false }, () => {
            this.GetReportData();
        });
    }

    LoadComments = (e, item) => {
        e.stopPropagation();
        this.setState({ IsCommentModelOpen: true, CommentReferenceId: item.id });
    }

    CloseComments = () => {
        this.setState({ IsCommentModelOpen: false });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                var totalrecords = 0;
                if (nextProps.ReportData.returnObject != null && nextProps.ReportData.returnObject.length > 0) {
                    totalrecords = nextProps.ReportData.returnObject[0].totalrows
                }
                this.setState({ MissingData: nextProps.ReportData.returnObject, TotalRecords: totalrecords, PageSize: this.state.PageSize, PageNo: this.state.PageNo, loading: false, SelectALL: false, SelectedRecords: [] });
            }
            else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }

        if (nextProps.UpdateDescription !== this.props.UpdateDescription) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                this.setState({
                    loading: true, SelectALL: false, SelectedRecords: []
                }, () => {
                    toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({ loading: false }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }

        if (nextProps.UpdateCheckNo !== this.props.UpdateCheckNo) {
            if (nextProps.UpdateCheckNo.transactionStatus === 0) {
                this.setState({
                    loading: true, SelectALL: false, SelectedRecords: [], isEdited: false
                }, () => {
                    toast.success(`${nextProps.UpdateCheckNo.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({ loading: false }, () => {
                    toast.error(`${nextProps.UpdateCheckNo.resultMsg}`);
                });
            }
        }
    }

    refreshData = () => {
        if (!this.state.loading) {
            this.setState({ loading: true }, () => {
                this.GetReportData(false);
            });
        }
    }

    GetReportData(IsRefresh = false) {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.ChecksMissingReferenceNumber,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: IsRefresh,
            IsIgnore: true,
            isAllIgnoreUnignore: state.IsIgnoredFilter
        };
        this.props.GET_REPORT_DATA_BES(body);
    }

    onLinkClick = (e, rowData) => {
        e.stopPropagation();
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }

    UpdateItemCommentCount = (id, clearUnread) => {
        let data = this.state.MissingData;
        data.forEach(function (item) {
            if (item.id === id) {
                if (clearUnread === true) { item.unreviewCommentCount = 0; } else { item.commentCount++ }
            }
        });
        this.setState({ MissingData: data });
    }

    onRowEdit = (item) => {
        if (item.transactionType != "Payroll Check") {
            this.setState({ isEdited: true });
        }
    };

    onCancelEdit = () => {
        const updatedArray = this.state.MissingData.map(item => ({
            ...item,
            num: '',
        }));
        this.setState({ MissingData: updatedArray, isEdited: false });
    };

    ChangeCheckNo = (e, index) => {
        var data = this.state.MissingData;
        data[index].num = e.target.value
        this.setState({ MissingData: data });
    }

    UpdateCheckNo = () => {
        let filerData = this.state.MissingData.filter(x => x.num);
        if (filerData != null && filerData.length > 0) {
            let arrayData = []
            filerData.forEach((item) => {
                arrayData.push({ id: item.id, checkNumber: item.num });
            });
            let body = {
                lstTransactions: arrayData,
                companyId: this.state.companyId
            }
            this.setState({ loading: true }, () => {
                this.props.UpdateTransactionCheckNumber_BES(body);
            });
        } else {
            toast.error("Please enter atleast 1 record Check No.");
            return false;
        }
    }

    render() {
        let selectedItem = this.state.SelectedRecords;
        return (
            <React.Fragment>
                {this.state.IsCommentModelOpen ?
                    <CommonComments
                        CloseComments={this.CloseComments}
                        ColorCode={this.state.ColorCode}
                        ModuleType={ModuleType.GeneralReportType}
                        ReportType={ReportType.ChecksMissingReferenceNumber}
                        CompanyId={this.state.companyId}
                        RecordId={this.state.CommentReferenceId}
                        IsEmbeddedPage={this.state.IsEmbeddedPage}
                        UpdateItemCommentCount={this.UpdateItemCommentCount}
                        SilentRefreshData={() => { if (typeof this.GetReportData === "function") { this.GetReportData(false); } }}
                    >
                    </CommonComments> : ""}
                <div className="dashboardPage embeded-dashboard">
                    <ToastContainer autoClose={3000} />
                    {this.state.loading ? <div style={{ minHeight: 'calc(100vh - 155px)', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}><CircularProgress /></div>
                        :
                        <React.Fragment>
                            <div className="  page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                                <h2 className="mb-3 mb-sm-0">{this.state.companyName} | {LinkType.MissRefNo}</h2>
                                <Link className="home-link" to={this.state.HomeLink} > Home </Link>
                            </div>
                            <div className="padding-box app-wrapper bgcolor">
                                {/* Notes + right controls bottom-aligned; Update/Cancel inside same column so table does not shift. */}
                                <div className="row mt-1">
                                    <div className="col-md-7">
                                        <div style={{ paddingLeft: "20px", paddingRight: "12px", paddingTop: 0, marginTop: 0 }}>
                                            <h5 style={{ fontSize: "19px", color: "#334C5A", lineHeight: "1.5", fontWeight: 700, marginTop: "0px", marginBottom: "0px" }}>Training Tip – Use the "Check" transaction type for printed or handwritten checks.</h5>
                                            <h5 style={{ fontSize: "19px", color: "#334C5A", lineHeight: "1.5", fontWeight: 700, marginBottom: "12px" }}>Use the "Expense" transaction type for service charges, debit card transactions, withdrawals, and ACH debits.</h5>
                                            <h5 style={{ fontSize: "19px", color: "#334C5A", lineHeight: "1.5", fontWeight: 700, marginBottom: "0px" }}>Please add the check numbers to the check transactions.</h5>
                                            <h5 style={{ fontSize: "19px", color: "#334C5A", lineHeight: "1.5", fontWeight: 700, marginBottom: "0px" }}>Select the non-check entries and click "Got It" to confirm you will make sure future checks and non-check transactions are recorded correctly.</h5>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className='d-flex flex-column justify-content-end align-items-end h-100'>
                                            <div className="form-group d-flex mb-0 align-items-center">
                                                <Button variant="contained" className=" tr-bgcolor orangeColor jr-btn bg-teal text-white refresh-btn" onClick={() => this.refreshData()}>
                                                    <i className="zmdi zmdi-refresh "></i> Refresh Data</Button>
                                            </div>
                                            <div className='d-flex align-items-center' style={{ marginTop: "8px" }}>
                                                <div className='show-previously-box'>
                                                    <div className="form-group d-flex mb-0 align-items-center">
                                                        <h4 className="col-form-label mb-0">Show Previously Ignored Transactions:</h4>
                                                        <div className="dropdown-input-box">
                                                            <select style={{ backgroundColor: "#fff", marginRight: "10px" }} className="select-box arrow-box" onChange={this.HandleIgnored} value={this.state.IsIgnoredFilter} >
                                                                <option value={true}> YES </option>
                                                                <option value={false}> NO </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=''>
                                                    <div className="form-group d-flex mb-0 align-items-center">
                                                        <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnApplyIgnore()}>{this.state.IsIgnoredFilter ? "Revert" : "Got It"}</Button>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.isEdited === true &&
                                                <div className="form-group d-flex mb-0 align-items-center" style={{ marginTop: "12px" }}>
                                                    <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.UpdateCheckNo()}>Update Check No</Button>
                                                    <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn redishOrangecolor" onClick={() => this.onCancelEdit()}>Cancel</Button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive-material">
                                    <table className="table tablebox account-reconcilliation">
                                        <thead>
                                            <tr className="orangeColor">
                                                <th className={`td-width ${this.state.sortField === 'date' ? this.state.sortFormat === 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('date')}><p className="table-th-title">Date</p> </th>
                                                <th className={`td-width  ${this.state.sortField === 'transactionType' ? this.state.sortFormat === 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('transactionType')}><p className="table-th-title">Transaction Type</p> </th>
                                                <th className={`td-width ${this.state.sortField === 'num' ? this.state.sortFormat === 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('num')}><p className="table-th-title">Check No.</p> </th>
                                                <th className={`td-width ${this.state.sortField === 'name' ? this.state.sortFormat === 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}><p className="table-th-title">Name</p> </th>
                                                <th className={`td-width ${this.state.sortField === 'memoOrDescription' ? this.state.sortFormat === 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('memoOrDescription')}><p className="table-th-title">Memo/Description</p> </th>
                                                <th className={`td-width  text-center ${this.state.sortField === 'amount' ? this.state.sortFormat === 'A'
                                                    ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('amount')}><p className="table-th-title">Amount</p> </th>
                                                <th className="td-width-90 text-center">
                                                    <label className="container101 header-check">
                                                        <input className="second-check-box" type="checkbox" checked={!!this.state.SelectALL} onChange={(e) => this.SelectALL(e)} />
                                                        <span className="checkmark101 yellowMark white_border"></span>
                                                    </label>
                                                </th>
                                                <th className="td-width-90 text-center"><img src="/vendors/WhiteCommnet.png" alt="comments" /></th>
                                                <th className="td-width-90 text-center "><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(this.state.MissingData && this.state.MissingData.length > 0) ? this.state.MissingData.map((item, j) => (
                                                <tr key={j} onClick={(e) => this.onRowEdit(item)}>
                                                    <td>{item.date}</td>
                                                    <td>{item.transactionType} </td>
                                                    {this.state.isEdited === true && item.transactionType != "Payroll Check" ?
                                                        <td onClick={(e) => e.stopPropagation()} style={{ verticalAlign: 'middle' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', minHeight: '40px' }}>
                                                                <Textarea className="placheholder-color"
                                                                    value={item.num} name="num"
                                                                    style={{ 'lineHeight': '20px', resize: 'none', borderRadius: '5px', border: '2px solid #ccc', height: '28px', width: '100%', marginTop: 0, marginBottom: 0 }}
                                                                    resize={"false"} placeholder="" onChange={(e) => this.ChangeCheckNo(e, j)}
                                                                />
                                                            </div>
                                                        </td>
                                                        :
                                                        <td>{item.num} </td>
                                                    }
                                                    <td>{item.name}</td>
                                                    <td>{item.memoOrDescription}</td>
                                                    <td className="text-center">{numberWithCommas(item.amount)}</td>
                                                    <td onClick={(e) => e.stopPropagation()}>
                                                        <label className="container101">
                                                            <input
                                                                className="second-check-box"
                                                                type="checkbox"
                                                                checked={!!(this.state.SelectALL || (selectedItem.length > 0 && selectedItem.indexOf(item.id) > -1))}
                                                                onClick={(e) => this.onCheckboxClick(e, item)}
                                                                onChange={() => { }}
                                                            />
                                                            <span className="checkmark101 green_CheckMark"></span>
                                                        </label>
                                                    </td>
                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                        <div className="panel-commentCount">
                                                            <img src="/vendors/Vector Smart Object.png" alt="comments" className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} onClick={(e) => this.LoadComments(e, item)}></img>
                                                            {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted">{item.unreviewCommentCount}</span>}
                                                        </div>
                                                    </td>
                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Shape 1.png" alt="link" onClick={(e) => this.onLinkClick(e, item)}></img></td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td className="text-center" colSpan="9">
                                                        No issues here! Keep up the good work!
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <PaginationComponent
                                    selectedPageNo={this.state.PageNo}
                                    selectedSize={this.state.PageSize}
                                    TotalRecords={this.state.TotalRecords}
                                    ChangePageSize={this.ChangePageSize}
                                    ChangePage={this.ChangePage}
                                    CurrentRecords={this.state.MissingData.length}
                                >
                                </PaginationComponent>
                            </div>
                        </React.Fragment>
                    }
                </div>

            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateCheckNo: state.ReportData.UpdateCheckNo,
        UpdateDescription: state.ReportData.UpdateDescription
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA_BES,
        MARK_IGNORED_DATA_BES,
        Revert_Ignored_DATA_BES,
        UpdateTransactionCheckNumber_BES
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MissRefNo_Embedded);
